<template>
  <div class="repeat-group option-group d-flex">
    <template v-if="basicLang">
      <input type="text" class="form-control custom-input w-20 tag-name-input" v-model="name">
    </template>
    <template v-else>
      <input type="text" class="form-control custom-input w-20 tag-name-input" :placeholder="name"
             @update:modelValue="e => setTranslate('name', e)">
    </template>

    <template v-if="basicLang">
      <input type="text" class="form-control custom-input w-20 tag-name-input" v-model="gram">
    </template>
    <template v-else>
      <input type="text" class="form-control custom-input w-20 tag-name-input" :placeholder="gram"
             @update:modelValue="e => setTranslate('gram', e)">
    </template>


    <input type="text" class="form-control custom-input w-20 tag-name-input" v-model="article">

    <div class="price-input-group d-flex justify-content-between w-30">
      <input v-if="basic_price > 0" type="text" class="form-control custom-input price-input w-49"
             :value="basic_price" disabled>
      <input v-else type="text" class="form-control custom-input price-input w-49" v-model.number="price">

      <input type="text" class="form-control custom-input price-input w-49" v-model.number="price_old">
    </div>

    <Popper arrow :content="$static('ingr.si', 'Зображення інгредієнту')" hover placement="top"
            style="white-space: nowrap">
      <div class="img-upload btn-icon btn-icon-outline" @click="openFileManager">
        <span class="icon icon-picture"></span>
        <span class="loaded-picture bg" :style="{ 'background-image': $filters.backgroundImage(item.image) }"></span>
        <a href="#" class="btn-icon btn-remove btn-small" v-if="item.image" @click.prevent.stop="delImage">
          <span class="icon icon-trash-filled"></span>
        </a>
      </div>
    </Popper>


    <Popper arrow :content="$static('ingr.sc', 'Колір інгредієнту')" hover placement="top" style="white-space: nowrap">
      <div class="colorpicker btn-icon btn-icon-outline" @click.prevent.stop="openColorPicker">
        <span class="icon icon-colorpicker"></span>
        <span class="pick-color" :style="{ 'background-color': color }"></span>
        <a href="#" class="btn-icon btn-remove btn-small" v-if="item.color" @click.prevent.stop="delColor">
          <span class="icon icon-trash-filled"></span>
        </a>
      </div>
    </Popper>


    <div class="button-group d-flex ">
      <div class="button-group-name">
        {{ $static('option.btngr', 'Дії:') }}
      </div>
      <div class="buttons d-flex">
        <Popper arrow :content="$static('option.up', 'Нагору')" hover placement="top" style="white-space: nowrap">
          <button class="remove btn-icon  btn-icon-outline" @click="up">
            <span class="icon icon-up"></span>
          </button>
        </Popper>
        <Popper arrow :content="$static('option.down', 'Вниз')" hover placement="top" style="white-space: nowrap">
          <button class="remove btn-icon btn-icon-outline" @click="down">
            <span class="icon icon-down"></span>
          </button>
        </Popper>


        <Popper arrow :content="$static('option.del', 'Видалити')" hover placement="top"
                style="white-space: nowrap">
          <button class="remove btn-icon btn-icon-outline" @click="remove">
            <span class="icon icon-trash"></span>
          </button>
        </Popper>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  name    : 'ItemModificationRow',
  props   : ['item', 'lang', 'basic_price'],
  events  : [
    'up',
    'down',
    'remove',
    'color'
  ],
  computed: {
    basicLang() {
      return this.lang === ''
    },
    name     : {
      get() {
        return this.item ? this.item.name : ''
      },
      set(value) {
        if (this.item) {
          this.item.name = value
        }
      }
    },
    gram     : {
      get() {
        return this.item ? this.item.gram : ''
      },
      set(value) {
        if (this.item) {
          this.item.gram = value
        }
      }
    },
    article  : {
      get() {
        return this.item ? this.item.article : ''
      },
      set(value) {
        if (this.item) {
          this.item.article = value
        }
      }
    },
    price    : {
      get() {
        return this.basic_price > 0 ? this.basic_price : this.item ? this.item.price : ''
      },
      set(value) {
        if (this.item) {
          this.item.price = value
        }
      }
    },
    price_old: {
      get() {
        return this.item ? this.item.price_old : ''
      },
      set(value) {
        if (this.item) {
          this.item.price_old = value
        }
      }
    },
    color    : {
      get() {
        return this.item ? this.item.color : 'transparent'
      },
      set(value) {
        if (this.item) {
          this.item.color = value
        }
      }
    }
  },
  methods : {

    setTranslate(key, value) {
      if (!this.item.translate || Array.isArray(this.item.translate)) {
        this.item.translate = {}
      }
      if (!this.item.translate[this.lang]) {
        this.item.translate[this.lang] = {}
      }
      this.item.translate[this.lang][key] = value
    },
    delColor() {
      this.item.color = null;
    },
    delImage() {
      this.item.image = null;
    },
    openFileManager() {
      window.$('#file-manager').modal('show');
      this.$store.commit('onFileSelect', this.select);
    },
    select() {
      let images = this.$store.getters['fm/selectedItems'].map(i => encodeURI('/storage/' + i.path));
      if (images) {
        this.item.image = images[0]
      } else {
        this.item.image = null
      }
    },
    up() {
      this.$emit('up')
    },
    openColorPicker(event) {
      this.$emit('color', event)
    },
    down() {
      this.$emit('down')
    },
    remove() {
      this.$emit('remove')
    }
  }
}
</script>